module.exports = __webpack_public_path__ + "images/logo-bank-of-america.svg";